import { State } from 'src/types'
import { thumbBackOut, thumbBackWebSide } from './thumbFinger'
import { indexBackMiddleSide, indexBackWebSide } from './indexFinger'
import { middleBackIndexSide, middleBackRingSide } from './middleFinger'
import { ringBackLittleSide } from './ringFinger'
import { littleBackOut, littleBackRingSide } from './littleFinger'

const fingerColors = (backStyle: string, state: State) => {
  const indexWebColor = state?.indexWeb?.color
  const indexMiddleColor = state?.indexMiddle?.color
  const middleIndexColor = state?.middleIndex?.color
  const middleRingColor = state?.middleRing?.color
  const ringMiddleColor = state?.ringMiddle?.color
  const ringLittleColor = state?.ringLittle?.color
  const littleRingColor = state?.littleRing?.color

  switch (backStyle) {
    case 'crownBackStyle':
      return {
        indexWebColor,
        indexMiddleColor: state?.indexLeftMiddleRight?.color,
        middleIndexColor: state?.indexLeftMiddleRight?.color,
        middleRingColor: state?.middleLeftRingRight?.color,
        ringMiddleColor: state?.middleLeftRingRight?.color,
        ringLittleColor: state?.ringLeftLittleRight?.color,
        littleRingColor: state?.ringLeftLittleRight?.color
      }
    case 'firstBackStyle':
      return {
        indexWebColor: state?.thumbIndexMiddle?.color,
        indexMiddleColor: state?.thumbIndexMiddle?.color,
        middleIndexColor: state?.thumbIndexMiddle?.color,
        middleRingColor: state?.middleLeftRingRight?.color,
        // ringMiddleColor: state?.middleLeftRingRight?.color,
        ringLittleColor: state?.ringLeftLittleRight?.color,
        littleRingColor: state?.ringLeftLittleRight?.color
      }
    default:
      return {
        indexWebColor,
        indexMiddleColor,
        middleIndexColor,
        middleRingColor,
        ringMiddleColor,
        ringLittleColor,
        littleRingColor
      }
  }
}

export const fingers = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  const { indexWebColor, indexMiddleColor, middleIndexColor, middleRingColor, ringLittleColor, littleRingColor } = fingerColors(
    state?.backStyle?.value || state.baseModel?.backStyle,
    state
  )
  const thumbBackWebSideColor = state.thumbWeb?.value === 'unselected' ? state.thumbWebAndIndexWeb?.color : state.thumbWeb?.color
  // printLeatherTypeの値
  const printLeatherTypeValue = state.printLeatherType?.value || 'unselected'

  // 親指背面＿外側
  await thumbBackOut(ctx, state.thumbOut.color, printLeatherTypeValue)
  // 親指背面＿ウェブ側
  await thumbBackWebSide(ctx, thumbBackWebSideColor, printLeatherTypeValue)
  // 人差し指背面＿ウェブ側
  await indexBackWebSide(ctx, indexWebColor, printLeatherTypeValue)
  // 人差し指背面＿中指側
  await indexBackMiddleSide(ctx, indexMiddleColor, printLeatherTypeValue)
  // 中指背面＿人差し指側
  await middleBackIndexSide(ctx, middleIndexColor, printLeatherTypeValue)
  // 中指背面＿薬指側
  await middleBackRingSide(ctx, middleRingColor, printLeatherTypeValue)
  // 薬指背面＿小指側
  await ringBackLittleSide(ctx, ringLittleColor, printLeatherTypeValue)
  // 小指背面＿薬指側
  await littleBackRingSide(ctx, littleRingColor, printLeatherTypeValue)
  // 小指背面＿外側
  await littleBackOut(ctx, state.littleOut?.color, printLeatherTypeValue)
}
